import { render, staticRenderFns } from "./InsuranceReviewForReferralCard.vue?vue&type=template&id=1dece0b6"
import script from "./InsuranceReviewForReferralCard.vue?vue&type=script&lang=js"
export * from "./InsuranceReviewForReferralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports